export default function DatePicker(theme) {
  return {
    MuiPickersDay: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            backgroundColor: theme.palette.primary.main,
            "&:hover, &:focus": {
              backgroundColor: theme.palette.primary.light,
            },
          },
        },
      },
    },
  };
}
